const removeBidBrackets = () => {
    const bidCount = document.querySelector('.box-bid-count');

    if (bidCount) {
        // Remove brackets and wrapper span entirely
        bidCount.outerHTML = bidCount.querySelector('#show_bids').outerHTML;
        console.log("Bid brackets removed");
        return true;
    }
    return false;
};

// Run immediately
if (!removeBidBrackets()) {
    // Watch for Webkul injection
    const observer = new MutationObserver(() => {
        if (removeBidBrackets()) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
